const AuthActionType = {
  AUTHENTICATE: 'AUTHENTICATE',
  TOKEN_EXPIRED: 'TOKEN_EXPIRED',
  SHOW_MAX_NUM_AND_SURVEY: 'SHOW_MAX_NUM_AND_SURVEY',
  CHECKING_REDIRECTION: 'CHECKING_REDIRECTION',
  LOGOUT: 'LOGOUT'
}

export default AuthActionType
